import * as Yup from "yup";

export const revieAdultValidationSchema = Yup.object().shape({
  gender: Yup.string().optional(),
  bmi: Yup.number().test(
    "is-normal-bmi",
    "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।",
    (value) => {
      return (
        value !== undefined && Number(value) <= 30 && Number(value) >= 13.5
      );
    }
  ),
  height: Yup.string().required("उचाइ अनिवार्य छ"),
  weight: Yup.string().required("वजन अनिवार्य छ"),
  hasDisease: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  hasSurgery: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  hasCovid: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  isHealthy: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [true],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  isPregnant: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) =>
      schema
        .oneOf(
          [false],
          "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
        )
        .required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  hasAbortion: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  hasChildren: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  deliveryType: Yup.string().when("hasChildren", {
    is: true,
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  declaration: Yup.boolean()
    .oneOf([true], "Please accept terms and conditions to proceed.")
    .required("घोषणा अनिवार्य छ"),
  heightFeet: Yup.number().required("उचाइ (फिटमा) अनिवार्य छ"),
  heightInch: Yup.number().required("उचाइ (इन्चमा) अनिवार्य छ"),
  dateOfPregnancy: Yup.string().when(["hasChildren", "gender"], {
    is: (isPregnant: boolean, gender: string) =>
      gender && gender.toUpperCase() !== "MALE" && isPregnant === true,
    then: (schema) => schema.required("गर्भावस्थाको मिति अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  dateOfAbortion: Yup.string().when("hasAbortion", {
    is: true,
    then: (schema) => schema.required("गर्भपतनको मिति अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const childPolicyRevivalValidationSchema = Yup.object().shape({
  childHeight: Yup.string().required("बालकको उचाइ अनिवार्य छ"),
  bmi: Yup.number().test(
    "is-normal-bmi",
    "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।",
    (value) =>
      value !== undefined && Number(value) <= 30 && Number(value) >= 13.5
  ),
  proposerBmi: Yup.number().test(
    "is-normal-bmi",
    "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।",
    (value) => {
      return (
        value !== undefined && Number(value) <= 30 && Number(value) >= 13.5
      );
    }
  ),
  childHeightInch: Yup.string().required("बालकको उचाइ (इन्चमा) अनिवार्य छ"),
  childWeight: Yup.string().required("बालकको वजन अनिवार्य छ"),
  childHadDisease: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  childHadSurgeryOrAccident: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  childHadCovid: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  childIsHealthy: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [true],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  proposerHeight: Yup.string().required("प्रस्तावकको उचाइ अनिवार्य छ"),
  proposerWeight: Yup.string().required("प्रस्तावकको वजन अनिवार्य छ"),
  proposerHadDisease: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  proposerHadSurgeryOrAccident: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  proposerHadCovid: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [false],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),
  proposerIsHealthy: Yup.boolean()
    .required("यो जानकारी अनिवार्य छ")
    .oneOf(
      [true],
      "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
    ),

  isPregnant: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) =>
      schema
        .oneOf(
          [false],
          "तपाईं अगाडि बढ्न सक्नुहुन्न। सहायता को लागि कृपया नजिकको शाखामा वा ०१-५९७१४३३ / ९८०१९६६६३० मा सम्पर्क गर्नुहोस्।"
        )
        .required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  hasAbortion: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  hasChildren: Yup.boolean().when("gender", {
    is: (gender: string) => gender && gender.toUpperCase() !== "MALE",
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  deliveryType: Yup.string().when("hasChildren", {
    is: true,
    then: (schema) => schema.required("यो जानकारी अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  dateOfPregnancy: Yup.string().when(["hasChildren", "gender"], {
    is: (isPregnant: boolean, gender: string) =>
      gender && gender.toUpperCase() !== "MALE" && isPregnant === true,
    then: (schema) => schema.required("गर्भावस्थाको मिति अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  dateOfAbortion: Yup.string().when("hasAbortion", {
    is: true,
    then: (schema) => schema.required("गर्भपतनको मिति अनिवार्य छ"),
    otherwise: (schema) => schema.notRequired(),
  }),
  declaration: Yup.boolean()
    .oneOf([true], "Please accept terms and conditions to proceed.")
    .required("घोषणा अनिवार्य छ"),
});
